/**
 * Relative email localization fallback strings.
 *
 * These keys must be added to the remote L10N management system to appear in production.
 * This file provides fallback values so the relative email field works before L10N keys are provisioned.
 *
 * Keys to add to L10N system:
 *   addRelativeWithOtherInt.email           = "EMAIL"
 *   addRelativeWithOtherInt_email.placeholder = "Введите email"
 */

import I18n from 'i18n-js';

const RELATIVE_EMAIL_STRINGS = {
    ru: {
        addRelativeWithOtherInt: {
            email: 'EMAIL',
        },
        addRelativeWithOtherInt_email: {
            placeholder: 'Введите email',
        },
    },
    en: {
        addRelativeWithOtherInt: {
            email: 'EMAIL',
        },
        addRelativeWithOtherInt_email: {
            placeholder: 'Enter email',
        },
    },
};

const mergeDeep = (target, source) => {
    const result = { ...target };
    Object.keys(source).forEach((key) => {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            result[key] = mergeDeep(result[key] || {}, source[key]);
        } else if (!(key in (result || {}))) {
            result[key] = source[key];
        }
    });
    return result;
};

/**
 * Injects relative email localization fallback strings into the active i18n locale.
 * Only fills in keys that are not yet present (does not override existing L10N values).
 * Call this after setLocale() during app initialization.
 */
export const applyRelativeEmailFallbackStrings = () => {
    const locale = I18n.locale || 'ru';
    const fallback = RELATIVE_EMAIL_STRINGS[locale] || RELATIVE_EMAIL_STRINGS.ru;
    const existing = I18n.translations[locale] || {};
    I18n.translations[locale] = mergeDeep(existing, fallback);
};
